import React from 'react';
import { useTranslation } from 'react-i18next';
import '../i18n'; // Import the i18n configuratio
const TopicBlocks = ({ onTopicSelect }) => {
    const { t, i18n } = useTranslation();

    const exampleTopics = [
        t('topics.1'), t('topics.2'), t('topics.3'), t('topics.4'), t('topics.5'), t('topics.6'), t('topics.7'), t('topics.8'), t('topics.9'), t('topics.10'), t('topics.11')
    ];

    return (
        <div className="mt-2 mb-4">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">Example topics (click to select):</p>
            <div className="flex flex-wrap gap-2">
                {exampleTopics.map((topic) => (
                    <button
                        key={topic}
                        type='button'
                        onClick={() => onTopicSelect(topic)}
                        className="px-3 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 
                     dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 
                     rounded-md text-sm transition-colors cursor-pointer"
                    >
                        {topic}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TopicBlocks;